/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { PerformanceMA } from "src/app/domain/recovery/component/recovery-market-analysis/dto/PerformanceMA";
import { left } from "src/app/util/excelStyles";
import { Rows } from "../../../interfaces";
import { withCellStyles, getCell, spaceInsteadOfNull, formats } from "../../../utils";
import { MA_BY_COMPANY_HEADERS } from "src/app/domain/recovery/component/recovery-market-analysis/ma-by-company/ma-by-company.component";

export const getPreparedData = (data: PerformanceMA[]): Rows => {
  const newData: Rows = [];
  const headers = MA_BY_COMPANY_HEADERS;
  newData.push(headers);
  const mainRows = getManyRows(data, headers);
  newData.push(...mainRows);
  return newData;
};


const getManyRows = (data: PerformanceMA[], headers: string[]): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = data.map((per) => getNewMapping(per));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header], left));
    }
    rows.push(row);
  }
  return rows;
};

const getNewMapping = (perf: PerformanceMA): object => {
  const body = {
    Organization: perf.orgName ?? '',
    'Company name': perf.companyName ?? '',
    Industry: perf.sector ?? '',
    'Round date': perf.roundDate ?? '',
    "# of companies": perf.amountOfCompanies ?? '',
    "Investment 0-12": getCell({
      v: spaceInsteadOfNull(perf.costYear1),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    "Investment 12-24": getCell({
      v: spaceInsteadOfNull(perf.costYear2),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    "FMV 0-12": getCell({
      v: spaceInsteadOfNull(perf.fmvYear1),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    "FMV 12-24": getCell({
      v: spaceInsteadOfNull(perf.fmvYear1),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    "Total raised 0-12": getCell({
      v: spaceInsteadOfNull(perf.totalRoundYear1),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    "Total raised 12-24": getCell({
      v: spaceInsteadOfNull(perf.totalRoundYear2),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    '# of rounds 0-12': getCell({
      v: spaceInsteadOfNull(perf.amountOfRoundsYear1),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    '# of rounds 12-24': getCell({
      v: spaceInsteadOfNull(perf.amountOfRoundsYear2),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
  };
  return body;
};
